enum QuestionType {
  mood = "mood",
  boolean = "boolean",
  text = "text",
}

export default QuestionType;
